// import Swiper JS
import { Swiper, Navigation, Pagination, Scrollbar } from 'swiper';

// Install modules

// import Swiper styles
import 'swiper/swiper-bundle.css';
import './Carousel.scss';

Swiper.use([Navigation, Pagination, Scrollbar]);

class Carousel {

    constructor(){
        
        this.swiperList = [];
        const elList = document.getElementsByClassName('swiper-container');
       
        for (let el of elList) {
            
            const nextBtn = el.getElementsByClassName('swiper-button-next').item(0);
            const prevBtn = el.getElementsByClassName('swiper-button-prev').item(0);
            const pag = el.getElementsByClassName('swiper-pagination').item(0);

            const s = new Swiper(el, {
                loop: true,
                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn
                },
                pagination: {
                    el: pag,
                }
            });
            
            this.swiperList.push(s);
        }
    }
}

export default Carousel;


// WEBPACK FOOTER //
// ./src/components/contentblocks/carousel/carousel.js